import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Optional, SkipSelf } from '@angular/core';
import { createServiceApi, serviceTypes, combineEffectsWithProviders } from '@essent/common';
export { ProductDuration, SegmentType } from '@essent/common';
import * as i1 from '@ngrx/effects';
import { EffectsModule } from '@ngrx/effects';

const apiVersion$e = '2';
const getBAGRegistrationApi = createServiceApi('[ContractingState] get BAG registration', 'get', serviceTypes(), {
    getUrl: `/contracting/bag/v${apiVersion$e}`,
    version: apiVersion$e,
    getParams: payload => payload
});

const apiVersion$d = '1';
const getContractGroupsApi = createServiceApi('[ContractGroupsState] Get contract groups', 'get', serviceTypes(), {
    getUrl: `/contracting/contractgroups/v${apiVersion$d}`,
    version: apiVersion$d,
    getParams: input => ({ accountId: input.accountId })
});

const apiVersion$c = '1';
const getContractHistoryApi = createServiceApi('[ContractHistoryState] Get Contract History', 'get', serviceTypes(), {
    getUrl: `/contracting/contracthistory/v${apiVersion$c}`,
    version: apiVersion$c,
    getParams: payload => payload
});

const apiVersion$b = '1';
const getContractsBySupplyAddressApi = createServiceApi('[ContractState] Get contracts by supply address', 'get', serviceTypes(), {
    getUrl: `/contracting/contractsbysupplyaddress/v${apiVersion$b}`,
    version: apiVersion$b,
    getParams: payload => payload
});

const apiVersion$a = '1';
const getCooldownContractsApi = createServiceApi('[CooldownContractsState] Get Cooldown Contracts', 'get', serviceTypes(), {
    getUrl: `/caseManagement/contracts/v${apiVersion$a}`,
    version: apiVersion$a,
    getParams: payload => payload
});

const apiVersion$9 = '1';
const getMoveOutEndReasonsApi = createServiceApi('[MoveOutEndReasons] Get move out end reasons', 'get', serviceTypes(), {
    getUrl: `/contracting/moveout/endreasons/v${apiVersion$9}`,
    version: apiVersion$9,
    getParams: ({ customerSegment }) => ({ customerSegment })
});

const apiVersion$8 = '1';
const getMoveOutApi = createServiceApi('[GetMoveOut] Get Move out', 'get', serviceTypes(), {
    getUrl: `/contracting/moveout/v${apiVersion$8}`,
    version: apiVersion$8,
    getParams: payload => payload
});

const apiVersion$7 = '1';
const getPenaltyAmountApi = createServiceApi('[GetPenaltyAmount] Get Penalty amount', 'post', serviceTypes(), {
    getUrl: `/contracting/moveout/penalty/v${apiVersion$7}`,
    version: apiVersion$7,
    getParams: ({ accountId }) => ({ accountId }),
    getBody: ({ body }) => body
});

const apiVersion$6 = '1';
const putMoveOutApi = createServiceApi('[PutMoveOut] Put Move out', 'put', serviceTypes(), {
    getUrl: `/contracting/moveout/v${apiVersion$6}`,
    version: apiVersion$6,
    getParams: ({ accountId }) => ({ accountId }),
    getBody: ({ payload }) => payload
});

const apiVersion$5 = '1';
const getMoveDetailsApi = createServiceApi('[MoveDetailsState] Get Move Details', 'get', serviceTypes(), {
    getUrl: `/contracting/move/v${apiVersion$5}`,
    version: apiVersion$5,
    getParams: payload => payload
});

const apiVersion$4 = '1';
const putMoveDetailsApi = createServiceApi('[MoveDetailsState] Put Move Details', 'put', serviceTypes(), {
    getUrl: `/contracting/move/v${apiVersion$4}`,
    version: apiVersion$4,
    getParams: ({ accountId }) => ({ accountId }),
    getBody: ({ body }) => body
});

const apiVersion$3 = '1';
const getOfferApi = createServiceApi('[OfferState] Get Offer', 'post', serviceTypes(), {
    getUrl: `/contracting/offer/v${apiVersion$3}`,
    version: apiVersion$3,
    getParams: ({ params }) => params,
    getBody: ({ body }) => body
});

const apiVersion$2 = '1';
const getOnboardingStatusApi = createServiceApi('[CustomerState] Get onboarding status', 'get', serviceTypes(), {
    getUrl: `/contracting/onboardingcontractdetails/v${apiVersion$2}`,
    version: apiVersion$2,
    getParams: payload => payload
});

const apiVersion$1 = '1';
const postQuotationReactionApi = createServiceApi('[ContractingState] Post quotation reaction', 'post', serviceTypes(), {
    getUrl: `/contracting/contracts/quotation-reaction/v${apiVersion$1}`,
    version: apiVersion$1,
    getBody: payload => payload
});

var CaseStatus;
(function (CaseStatus) {
    CaseStatus["PROCESSSTARTED"] = "PROCESSSTARTED";
    CaseStatus["PROCESSFINALIZED"] = "PROCESSFINALIZED";
    CaseStatus["PROCESSCANCELLED"] = "PROCESSCANCELLED";
    CaseStatus["PROCESSABORTED"] = "PROCESSABORTED";
})(CaseStatus || (CaseStatus = {}));

var MoveInStatus;
(function (MoveInStatus) {
    MoveInStatus["MOVEINSTARTED"] = "MOVEINSTARTED";
    MoveInStatus["WAITFORMOVEINADDRESS"] = "WAITFORMOVEINADDRESS";
    MoveInStatus["WAITFORMOVEINDATE"] = "WAITFORMOVEINDATE";
    MoveInStatus["WAITFORMOVEIN"] = "WAITFORMOVEIN";
    MoveInStatus["MOVEINFINALIZED"] = "MOVEINFINALIZED";
    MoveInStatus["MOVEINCANCELLED"] = "MOVEINCANCELLED";
    MoveInStatus["MOVEINABORTED"] = "MOVEINABORTED";
    MoveInStatus["WAITFORMOVEINDATA"] = "WAITFORMOVEINDATA";
    MoveInStatus["ADDPRODUCT"] = "ADDPRODUCT";
    MoveInStatus["WAITFORMETERREADINGSMOVEIN"] = "WAITFORMETERREADINGSMOVEIN";
})(MoveInStatus || (MoveInStatus = {}));

var MoveOutStatus;
(function (MoveOutStatus) {
    MoveOutStatus["MOVEOUTSTARTED"] = "MOVEOUTSTARTED";
    MoveOutStatus["WAITFORMOVEOUT"] = "WAITFORMOVEOUT";
    MoveOutStatus["MOVEOUTFINALIZED"] = "MOVEOUTFINALIZED";
    MoveOutStatus["MOVEOUTCANCELLED"] = "MOVEOUTCANCELLED";
    MoveOutStatus["MOVEOUTABORTED"] = "MOVEOUTABORTED";
    MoveOutStatus["WAITFORMOVEOUTDATA"] = "WAITFORMOVEOUTDATA";
    MoveOutStatus["WAITFORMOVEOUTDATE"] = "WAITFORMOVEOUTDATE";
    MoveOutStatus["WAITFORMETERREADINGSMOVEOUT"] = "WAITFORMETERREADINGSMOVEOUT";
})(MoveOutStatus || (MoveOutStatus = {}));

var EndContractStatus;
(function (EndContractStatus) {
    EndContractStatus["MOVEOUTSTARTED"] = "MOVEOUTSTARTED";
    EndContractStatus["WAITFORMOVEOUT"] = "WAITFORMOVEOUT";
    EndContractStatus["MOVEOUTFINALIZED"] = "MOVEOUTFINALIZED";
    EndContractStatus["MOVEOUTCANCELLED"] = "MOVEOUTCANCELLED";
    EndContractStatus["MOVEOUTABORTED"] = "MOVEOUTABORTED";
    EndContractStatus["WAITFORMOVEOUTDATA"] = "WAITFORMOVEOUTDATA";
    EndContractStatus["WAITFORMOVEOUTDATE"] = "WAITFORMOVEOUTDATE";
    EndContractStatus["WAITFORMETERREADINGSMOVEOUT"] = "WAITFORMETERREADINGSMOVEOUT";
    EndContractStatus["WAITFORMOVEOUTENDCONTRACT"] = "WAITFORMOVEOUTENDCONTRACT";
    EndContractStatus["MOVEOUTSTARTEDFORENDCONTRACT"] = "MOVEOUTSTARTEDFORENDCONTRACT";
})(EndContractStatus || (EndContractStatus = {}));

var ContractStatus;
(function (ContractStatus) {
    ContractStatus["ACTIVE"] = "active";
    ContractStatus["FUTURE"] = "future";
    ContractStatus["PAST"] = "past";
})(ContractStatus || (ContractStatus = {}));

/**
 * @ignore
 */
const API = new InjectionToken('api-contract');

const apiVersion = '1';
const getContractGroupsWithPaymentDetailsApi = createServiceApi('[ContractGroupsWithPaymentDetailsState] Get contract groups with payment details', 'get', serviceTypes(), {
    getUrl: `/contracting/contractgroups/paymentdetails/v${apiVersion}`,
    version: apiVersion,
    getParams: input => ({ accountId: input.accountId })
});

const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(getMoveDetailsApi, putMoveDetailsApi, getMoveOutApi, putMoveOutApi, getMoveOutEndReasonsApi, getPenaltyAmountApi, getOnboardingStatusApi, getContractGroupsApi, getContractGroupsWithPaymentDetailsApi, getContractHistoryApi, getOfferApi, getCooldownContractsApi, getContractsBySupplyAddressApi, getBAGRegistrationApi, postQuotationReactionApi);
/**
 * Module containing all providers.
 *
 * ### Example usage
 *
 * #### Normal
 * ```typescript
 * providers: [
 *     ContractCoreModule,
 *     ...
 * ]
 * ```
 *
 * #### Custom API
 *
 * ```typescript
 * providers: [
 *     ContractCoreModule.forRoot({
 *         api: 'https://my-api.com'
 *     }),
 *     ...
 * ]
 * ```
 */
class ContractCoreModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('ContractCoreModule is imported more than once.');
        }
    }
    static forRoot(config) {
        return {
            ngModule: ContractCoreModule,
            providers: [
                {
                    provide: API,
                    useValue: config ? config.api : undefined
                }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: ContractCoreModule, deps: [{ token: ContractCoreModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.7", ngImport: i0, type: ContractCoreModule, imports: [i1.EffectsFeatureModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: ContractCoreModule, providers: PROVIDERS, imports: [EffectsModule.forFeature(EFFECTS)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: ContractCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [EffectsModule.forFeature(EFFECTS)],
                    providers: PROVIDERS
                }]
        }], ctorParameters: () => [{ type: ContractCoreModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

const { getContractGroups, getContractGroupsSuccess, getContractGroupsError, getContractGroupsClear, getContractGroupsActions } = getContractGroupsApi;

const { getContractGroupsWithPaymentDetails, getContractGroupsWithPaymentDetailsSuccess, getContractGroupsWithPaymentDetailsError, getContractGroupsWithPaymentDetailsClear, getContractGroupsWithPaymentDetailsActions } = getContractGroupsWithPaymentDetailsApi;

const { getContractHistory, getContractHistorySuccess, getContractHistoryError, getContractHistoryClear, getContractHistoryActions } = getContractHistoryApi;

const { getContractsBySupplyAddressActions, getContractsBySupplyAddress, getContractsBySupplyAddressSuccess, getContractsBySupplyAddressError, getContractsBySupplyAddressClear } = getContractsBySupplyAddressApi;

const { getCooldownContracts, getCooldownContractsSuccess, getCooldownContractsError, getCooldownContractsClear, getCooldownContractsActions } = getCooldownContractsApi;

var TargetAddressTypes;
(function (TargetAddressTypes) {
    TargetAddressTypes["MOVE_IN"] = "move_in";
    TargetAddressTypes["MOVE_OUT"] = "move_out";
    TargetAddressTypes["TEMPORARY"] = "temp";
})(TargetAddressTypes || (TargetAddressTypes = {}));

const { putMoveDetails, putMoveDetailsSuccess, putMoveDetailsError, putMoveDetailsClear, putMoveDetailsActions } = putMoveDetailsApi;
const { getMoveDetails, getMoveDetailsSuccess, getMoveDetailsError, getMoveDetailsClear, getMoveDetailsActions } = getMoveDetailsApi;

const { getOffer, getOfferSuccess, getOfferError, getOfferClear, getOfferActions } = getOfferApi;

const { getPenaltyAmount, getPenaltyAmountSuccess, getPenaltyAmountError, getPenaltyAmountClear, getPenaltyAmountActions } = getPenaltyAmountApi;
const { getMoveOut, getMoveOutSuccess, getMoveOutError, getMoveOutClear, getMoveOutActions } = getMoveOutApi;
const { putMoveOut, putMoveOutSuccess, putMoveOutError, putMoveOutClear, putMoveOutActions } = putMoveOutApi;

const { getOnboardingStatus, getOnboardingStatusSuccess, getOnboardingStatusError, getOnboardingStatusClear, getOnboardingStatusActions } = getOnboardingStatusApi;

var MeterType;
(function (MeterType) {
    MeterType["SMART"] = "smart";
    MeterType["MIXED"] = "mixed";
    MeterType["CONVENTIONAL"] = "conventional";
})(MeterType || (MeterType = {}));

var ProcessType;
(function (ProcessType) {
    ProcessType["MOVEIN"] = "move_in";
    ProcessType["SWITCHIN"] = "switch_in";
})(ProcessType || (ProcessType = {}));

var StepName;
(function (StepName) {
    StepName["LOGIN"] = "login";
    StepName["OLDCONTRACT"] = "oldcontract";
    StepName["CONTRACTCONFIRMATION"] = "contractconfirmation";
    StepName["DELIVERYSTART"] = "deliverystart";
    StepName["METEREADINGS"] = "meterreadings";
})(StepName || (StepName = {}));
var StepStatus;
(function (StepStatus) {
    StepStatus["COMPLETED"] = "completed";
    StepStatus["INPROGRESS"] = "in-progress";
})(StepStatus || (StepStatus = {}));

const { getMoveOutEndReasons, getMoveOutEndReasonsSuccess, getMoveOutEndReasonsError, getMoveOutEndReasonsClear, getMoveOutEndReasonsActions } = getMoveOutEndReasonsApi;

const { getBagRegistration: getBAGRegistration, getBagRegistrationActions: getBAGRegistrationActions, getBagRegistrationClear: getBAGRegistrationClear, getBagRegistrationError: getBAGRegistrationError, getBagRegistrationSuccess: getBAGRegistrationSuccess } = getBAGRegistrationApi;

var BAGIntendedUse;
(function (BAGIntendedUse) {
    BAGIntendedUse["RESIDENTIAL_FUNCTION"] = "woonfunctie";
    BAGIntendedUse["MEETING_FUNCTION"] = "bijeenkomstfunctie";
    BAGIntendedUse["CELL_FUNCTION"] = "celfunctie";
    BAGIntendedUse["HEALTH_CARE_FUNCTION"] = "gezondheidszorgfunctie";
    BAGIntendedUse["INDUSTRY_FUNCTION"] = "industriefunctie";
    BAGIntendedUse["OFFICE_FUNCTION"] = "kantoorfunctie";
    BAGIntendedUse["LODGING_FUNCTION"] = "logiesfunctie";
    BAGIntendedUse["EDUCATIONAL_FUNCTION"] = "onderwijsfunctie";
    BAGIntendedUse["SPORTS_FUNCTION"] = "sportfunctie";
    BAGIntendedUse["SHOP_FUNCTION"] = "winkelfunctie";
    BAGIntendedUse["OTHER_USAGE_FUNCTION"] = "overige gebruiksfunctie";
})(BAGIntendedUse || (BAGIntendedUse = {}));

const { postQuotationReaction, postQuotationReactionActions, postQuotationReactionClear, postQuotationReactionError, postQuotationReactionSuccess } = postQuotationReactionApi;

var QuotationReactionCode;
(function (QuotationReactionCode) {
    QuotationReactionCode["ACCEPTED"] = "2001";
    QuotationReactionCode["REJECTED"] = "2002";
    QuotationReactionCode["INVALID_TOKEN"] = "4001";
    QuotationReactionCode["TOKEN_EXPIRED"] = "4002";
    QuotationReactionCode["ALREADY_PROCESSED"] = "4003";
    QuotationReactionCode["NOT_FOUND"] = "4004";
    QuotationReactionCode["NOT_READY"] = "4005";
})(QuotationReactionCode || (QuotationReactionCode = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { API, BAGIntendedUse, CaseStatus, ContractCoreModule, ContractStatus, EndContractStatus, MeterType, MoveInStatus, MoveOutStatus, ProcessType, QuotationReactionCode, StepName, StepStatus, TargetAddressTypes, getBAGRegistration, getBAGRegistrationActions, getBAGRegistrationClear, getBAGRegistrationError, getBAGRegistrationSuccess, getContractGroups, getContractGroupsActions, getContractGroupsClear, getContractGroupsError, getContractGroupsSuccess, getContractGroupsWithPaymentDetails, getContractGroupsWithPaymentDetailsActions, getContractGroupsWithPaymentDetailsClear, getContractGroupsWithPaymentDetailsError, getContractGroupsWithPaymentDetailsSuccess, getContractHistory, getContractHistoryActions, getContractHistoryClear, getContractHistoryError, getContractHistorySuccess, getContractsBySupplyAddress, getContractsBySupplyAddressActions, getContractsBySupplyAddressClear, getContractsBySupplyAddressError, getContractsBySupplyAddressSuccess, getCooldownContracts, getCooldownContractsActions, getCooldownContractsClear, getCooldownContractsError, getCooldownContractsSuccess, getMoveDetails, getMoveDetailsActions, getMoveDetailsClear, getMoveDetailsError, getMoveDetailsSuccess, getMoveOut, getMoveOutActions, getMoveOutClear, getMoveOutEndReasons, getMoveOutEndReasonsActions, getMoveOutEndReasonsClear, getMoveOutEndReasonsError, getMoveOutEndReasonsSuccess, getMoveOutError, getMoveOutSuccess, getOffer, getOfferActions, getOfferClear, getOfferError, getOfferSuccess, getOnboardingStatus, getOnboardingStatusActions, getOnboardingStatusClear, getOnboardingStatusError, getOnboardingStatusSuccess, getPenaltyAmount, getPenaltyAmountActions, getPenaltyAmountClear, getPenaltyAmountError, getPenaltyAmountSuccess, postQuotationReaction, postQuotationReactionActions, postQuotationReactionClear, postQuotationReactionError, postQuotationReactionSuccess, putMoveDetails, putMoveDetailsActions, putMoveDetailsClear, putMoveDetailsError, putMoveDetailsSuccess, putMoveOut, putMoveOutActions, putMoveOutClear, putMoveOutError, putMoveOutSuccess };
